"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import type { Assessment } from "@/features/assessment/types";
import type { AppLocale } from "@/core/i18n/config";
import { AssessmentGridCard } from "./assessment-grid-card";
interface AssessmentGridSectionProps {
  assessments: Assessment[];
  locale: AppLocale;
}
export function AssessmentGridSection(t0) {
  const $ = _c(25);
  const {
    assessments,
    locale
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 20
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      once: true
    };
    t4 = {
      duration: 0.6
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  const t5 = locale === "hi" ? "\u0938\u092D\u0940 \u0905\u0938\u0947\u0938\u092E\u0947\u0902\u091F" : "All Assessments";
  let t6;
  if ($[4] !== t5) {
    t6 = <p className="mb-2 text-[11px] font-bold tracking-[0.2em] text-primary uppercase">{t5}</p>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = locale === "hi" ? "\u091C\u093E\u0928\u093F\u090F \u0906\u092A \u0915\u0939\u093E\u0901 \u0939\u0948\u0902 \u2014 \u092C\u093F\u0928\u093E \u0915\u093F\u0938\u0940 \u0928\u093F\u0930\u094D\u0923\u092F \u0915\u0947" : "Find out where you stand \u2014 without any judgment";
  let t8;
  if ($[6] !== t7) {
    t8 = <h2 className="font-heading text-2xl font-light tracking-tight text-foreground sm:text-3xl lg:text-4xl">{t7}</h2>;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = locale === "hi" ? "\u0939\u0930 \u0905\u0938\u0947\u0938\u092E\u0947\u0902\u091F \u0906\u092A\u0915\u094B \u0905\u092A\u0928\u0940 \u092D\u093E\u0935\u0928\u093E\u0924\u094D\u092E\u0915 \u0938\u094D\u0925\u093F\u0924\u093F \u0915\u094B \u092C\u0947\u0939\u0924\u0930 \u0922\u0902\u0917 \u0938\u0947 \u0938\u092E\u091D\u0928\u0947 \u092E\u0947\u0902 \u092E\u0926\u0926 \u0915\u0930\u0924\u093E \u0939\u0948\u0964" : "Each assessment helps you better understand your emotional state and what support may help.";
  let t10;
  if ($[8] !== t9) {
    t10 = <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed font-light text-muted-foreground">{t9}</p>;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t10 || $[11] !== t6 || $[12] !== t8) {
    t11 = <motion.div initial={t1} whileInView={t2} viewport={t3} transition={t4} className="mb-12 text-center">{t6}{t8}{t10}</motion.div>;
    $[10] = t10;
    $[11] = t6;
    $[12] = t8;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="mb-12 border-b border-border" />;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== assessments || $[16] !== locale) {
    let t14;
    if ($[18] !== locale) {
      t14 = (assessment, i) => <AssessmentGridCard key={assessment.id} assessment={assessment} locale={locale} index={i} />;
      $[18] = locale;
      $[19] = t14;
    } else {
      t14 = $[19];
    }
    t13 = assessments.map(t14);
    $[15] = assessments;
    $[16] = locale;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[20] !== t13) {
    t14 = <div className="grid grid-cols-2 gap-x-8 gap-y-12 sm:grid-cols-3 lg:grid-cols-3">{t13}</div>;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t11 || $[23] !== t14) {
    t15 = <section className="bg-card px-4 py-16 sm:px-6 lg:px-8"><div className="mx-auto max-w-7xl">{t11}{t12}{t14}</div></section>;
    $[22] = t11;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  return t15;
}